import { render, staticRenderFns } from "./savedEmailModels.vue?vue&type=template&id=14908218&scoped=true&"
import script from "./savedEmailModels.vue?vue&type=script&lang=js&"
export * from "./savedEmailModels.vue?vue&type=script&lang=js&"
import style0 from "./savedEmailModels.vue?vue&type=style&index=0&id=14908218&prod&scoped=true&lang=css&"
import style1 from "./savedEmailModels.vue?vue&type=style&index=1&id=14908218&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14908218",
  null
  
)

export default component.exports